<template>
     <v-app-bar 
     id="app_toolbar" app flat prominent dark dense absolute fixed clipped-left style="position:fixed"
      v-if="authenticated"
      color="#7F99AC"
      src="/img/header_bg.png"
     
     >
      <!--v-app-bar-nav-icon @click.stop="toggleDrawer"></v-app-bar-nav-icon-->
       
       
       <v-toolbar-title class="headline text-uppercase" v-if="selected && selected._supplier && selected._supplier.name && !selected.disabled & !Role('supplier')">
                               <img class="app-logo" src="/img/logo-nkc-white.png">
                            <span>
                            <span class="font-weight-light mb-2">Nederlands</span>
                            <span>KENNIS</span>
                            <span class="font-weight-light mb-2">Centrum</span>
                            </span>
                                  <!--
                                  <img class="app-logo selected" src="/img/logo-nkc-white.png">
                                  <v-icon color="white" v-if="!Role('lead')">navigate_before</v-icon>
                                  <v-avatar v-if="(selected._supplier.logo)" class="ma-0 mr-2">
                                  <v-img v-avatar:logo :src="selected._supplier.logo"></v-img>
                                  </v-avatar>
                                  {{selected._supplier.name}}
                          <v-list-item-subtitle style="margin-top: -13px;" v-if="selected.track">{{selected.track}}: {{tags.join(", ")}}</v-list-item-subtitle>
                          -->
                           </v-toolbar-title>
                            <v-toolbar-title v-else-if="selected.name" class="headline " @click="home">
                            <img class="app-logo selected" src="/img/logo-nkc-white.png">
                            {{selected.name}}
                             <v-list-item-subtitle style="margin-top: -13px;" v-if="selected.track">{{selected.track}}: {{tags.join(", ")}}</v-list-item-subtitle>
                          </v-toolbar-title>
                          <v-toolbar-title v-else class="headline text-uppercase" @click="home">
                           <img class="app-logo" src="/img/logo-nkc-white.png">
                            <span class="font-weight-light mb-2">Nederlands</span>
                            <span>KENNIS</span>
                            <span class="font-weight-light mb-2">Centrum</span>
                          </v-toolbar-title>
                          <slot></slot>
                          
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                            <v-btn text to="/" v-if="false && authenticated">Start</v-btn>
                            
                          </v-toolbar-items>
                         
      
          <v-btn text @click="doLogout" v-if="authenticated">
              <v-icon>power_settings_new</v-icon>&nbsp;&nbsp;{{settings.name}}
            </v-btn>
              <v-btn v-else icon  @click="doLogout">
              <v-icon>lock</v-icon>
            </v-btn>

    </v-app-bar>
   
</template>

<script>

import {
  mapMutations,
  mapGetters,
  mapState,
  mapActions
} from 'vuex'

export default {
  data: () => ({
      tabs: 0,
      searching: false,
      search: '',
      showLogin: false,
      profile: false,
      hover: false,
      items: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' }
      ]
    }),
  computed: {
    ...mapGetters('auth', ["Role"]),
     ...mapState('app', ['drawer','menu','theme','view','software']),
     ...mapState('auth', ['settings','authenticated','relation']),
     ...mapGetters('tag',['list','selectedTags','selectedNames']),
     ...mapState('match', ['selected','list']),
     height () {
       if (this.selected>5) return 150
       return 50
     },
      tags () {
        if (this.selected.tags) return this.selected.tags.filter(q=> q.type=='branche' || q.type=='category' || q.type=='type').map(t => {
            if (t.type == 'category' || t.type == 'type') {
              t.path = t.path.replaceAll(' / ', '###')
              t.name = t.path.split('/').map(c => c.capitalize()).join(', ').replaceAll('###',' / ')
            }
            return t.name
        }) //
        return []
      }
    },
  watch: {
    '$route' (val) {
      this.title = val.name
    }
  },

  mounted () {
    this.$nextTick(() => {
      if (!this.authenticated && this.$router.secure) this.showLogin = true
    })
    
  },
  beforeDestroy () {
   
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer','toggleMenu']),
    ...mapMutations('tag', ['setSelected','removeSelected']),
    ...mapMutations('match', ['setSelected']),
     ...mapActions('tag', ['updateCount']),
     ...mapActions('auth', ['logout']),
    removeTag(item){
      this.removeSelected(item)
      this.updateCount({tags: this.selectedNames, type: this.view.type, limit: this.view.limit, min: this.view.percentage})
    },
    home () {
      //this.$router.push('/')
    },
    onBlur() {
        this.searching = false
        this.search = ''
    },
    searchBegin() {
      console.log(this.$refs)
        this.$refs.combo.$el.focus().click()
        //this.searching = true
        //setTimeout(() => document.querySelector('#search').focus(), 50)
    },
    searchEnd() {
        this.searching = false
        this.search = ''
        //document.querySelector('#search').blur()
    },
    doLogout(){
       this.$router.push('/')
       this.logout()
    },
    loadPDF(){
      window.open('/gamze.pdf')
    }
  }
}
</script>